import styled, { css } from 'styled-components'

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']};
    max-width: 50rem;
    width: 100%;
    outline: none;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius['4']};
    box-shadow: ${theme.shadow.xl};
  `,
)

export const Icon = styled.img(
  ({ theme }) => css`
    align-self: center;
    width: 12rem;
    height: 12rem;
    object-fit: scale-down;
    margin: ${theme.space['40']} ${theme.space['0']} ${theme.space['24']};
  `,
)

export const Title = styled.h2(
  ({ theme }) => css`
    font-size: 2.4rem;
    font-weight: 600;
    line-height: 3.2rem;
    color: ${theme.colors.black700};
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['0']} ${theme.space['8']};
  `,
)

export const SubTitle = styled.p(
  ({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    color: ${theme.colors.black500};
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['0']} ${theme.space['40']};
  `,
)

export const SupportSection = styled.section(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.space['8']};
    padding: ${theme.space['16']};
    margin: ${theme.space['16']} ${theme.space['0']};
    border-radius: ${theme.border.radius['8']};
    background-color: ${theme.colors.gray200};
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.black600};

    > svg {
      background-color: ${theme.colors.black500};
      color: ${theme.colors.white};
      border-radius: ${theme.border.radius['circle']};
      padding: ${theme.space['4']};
      margin-top: ${theme.space['2']};
    }

    a {
      color: ${theme.colors.marketShopBrand800};
    }
  `,
)
